import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

import Chip from '../Chip'

library.add(faUsers)

interface SharePrivateProps {
  active?: boolean
  onClick?: () => void
}

const BoxIcon = () => (
  <span className="flex justify-center items-center bg-gray-200 w-10 h-10 min-w-10 rounded-lg">
    <FontAwesomeIcon
      className="text-lg text-gray-500"
      icon={['fas', 'users']}
    />
  </span>
)

const SharePrivate = ({ active, onClick }: SharePrivateProps) => {
  return (
    <Chip
      icon={<BoxIcon />}
      highlight
      highlightCustomClass="p-3 flex-col gap-y-3 sm:flex-1"
      active={active}
      onClick={onClick}
    >
      <span className="flex flex-col gap-y-1">
        <Title size="2XS">
          <Trans>Condividi privatamente</Trans>
        </Title>
        <Paragraph className="text-gray-500 sm:max-w-sm sm:w-auto">
          <Trans>
            Condividi solo con chi vuoi tu e assegna permessi in sola lettura o
            di modifica. Genera link con token per condividere con semplicità e
            sicurezza.
          </Trans>
        </Paragraph>
      </span>
    </Chip>
  )
}

export default SharePrivate
